<template>
  <div>
    <Input
      @on-focus="openGroup = true"
      :value="name"
      readonly
      placeholder="请选择"
      clearable
      @on-clear="clear"
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width="450"
      draggable
      class="my-drawer"
    >
      <deviceTool @car="reCar" :filter='filter' :filterGroup='filterGroup'></deviceTool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement","filter",'filterGroup'],
  data() {
    return {
      openGroup: false,
    };
  },
  methods: {
    reCar(v) {
      
      this.openGroup = false;
      this.$emit("update:id", v.id);
      this.$emit("update:idList", [v.id]);
      this.$emit("update:name", v.bind);
      this.$emit("update:deviceNo", v.deviceNo);
      this.$emit("update:useType", v.useType);
      this.$emit("device", v);
    },
    clear(){
      console.log(123);
      this.$emit("update:id", '');
      this.$emit("update:idList", []);
      this.$emit("update:name",'');
      this.$emit("update:deviceNo", '');
      this.$emit("update:useType", '');
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectDevice.vue